import { QueryList } from '@angular/core';
import { CustomFormComponent } from './custom-form/custom-form.component';

export type CustomFormsValidation =
  | { status: 'not-ready' }
  | { status: 'invalid'; title: string; message: string }
  | { status: 'valid' };

export function validateCustomForms(
  formComponents: QueryList<CustomFormComponent> | CustomFormComponent[],
): CustomFormsValidation {
  const forms = Array.isArray(formComponents) ? formComponents : formComponents.toArray();
  if (forms.some(form => !form.customForm)) {
    return { status: 'not-ready' };
  }
  forms.forEach(form => form.customForm?.form.markAllAsTouched());
  const problems = forms
    .map(form => ({ section: form.sectionTitle, fields: form.getMissingRequiredFieldNames() }))
    .filter(problem => problem.fields.length > 0);
  if (problems.length > 0) {
    return {
      status: 'invalid',
      title: 'Pflichtfelder fehlen',
      message: problems.map(p => `${p.section}: ${p.fields.join(', ')}`).join(' | '),
    };
  }
  if (forms.some(form => form.customForm?.form.invalid)) {
    return { status: 'invalid', title: 'Eingaben unvollständig', message: 'Bitte die markierten Felder prüfen.' };
  }
  return { status: 'valid' };
}
